const CANCER_TAGS = {
    'BLCA': 'Bladder cancer',
    'BRCA': 'Breast invasive carcinoma',
    'COAD': 'Colon adenocarcinoma',
    'DLBC': 'Lymphoid Neoplasm Diffuse Large B-cell Lymphoma',
    'ESCA': 'Esophageal carcinoma',
    'GBM': 'Glioblastoma multiforme',
    'GLI': 'Gliomas',
    'KIRC': 'Kidney renal clear cell carcinoma',
    'LAML': 'Acute Myeloid Leukemia',
    'LGG': 'Low grade gliomas',
    'LIHC': 'Liver hepatocellular carcinoma',
    'LUAD': 'Lung adenocarcinoma',
    'LUSC': 'Lung squamous cell carcinoma',
    'OV': 'Ovarian serous cystadenocarcinoma',
    'PAAD': 'Pancreatic adenocarcinoma',
    'PRAD': 'Prostate adenocarcinoma',
    'READ': 'Rectum adenocarcinoma',
    'SKCM': 'Skin Cutaneous Melanoma',
    'STAD': 'Stomach adenocarcinoma',
    'THCA': 'Thyroid carcinoma',
    'UCEC': 'Uterine Corpus Endometrial Carcinoma',
    'UCS': 'Uterine Carcinosarcoma',
}


class CancerTypes {
    all_tag_names() {
        return CANCER_TAGS.keys().sort()
    }
    tag_lookup() {
        return CANCER_TAGS
    }
    get_description(tagname) {
        return CANCER_TAGS[tagname]
    }
}

export default CancerTypes;